import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from '../../environments/environment';
import { DatadogContextData, DatadogDynamicConfig, DatadogEnvironment, DatadogUserData } from '../../interfaces';
import { DatadogInternalConfig } from '../../interfaces/datadog/datadog-internal.interface';

@Injectable({
  providedIn: 'root',
})
export class DatadogService {
  initService(datadogConfig: DatadogDynamicConfig) {
    if (datadogConfig.env === DatadogEnvironment.DEV) {
      return;
    }

    const internalConfig: DatadogInternalConfig = {
      site: 'datadoghq.com',
      version: '1.0.0',
      sampleRate: 100,
      trackInteractions: true,
      allowedTracingOrigins: [/https?:\/\/.*\.datanyze\.com/],
    };
    datadogRum.init({ ...internalConfig, ...datadogConfig });
  }

  isDatadogActive() {
    return !!window['DD_RUM'];
  }

  setUserId(userData: DatadogUserData) {
    datadogRum.setUser({ ...userData });
  }

  addCustomAction(actionName: string, context: DatadogContextData) {
    datadogRum.addAction(actionName, context);
  }

  addGlobalContext(key: string, value: string) {
    datadogRum.addRumGlobalContext(key, value);
  }

  setGlobalContext(context: DatadogContextData) {
    datadogRum.setRumGlobalContext(context);
  }
}
